// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"abdc7c25","217":"afc45430","453":"3959d9c0","544":"523282cd","591":"fcd18382","698":"234ef996","956":"e01955e4","963":"d5ab138c"}[chunkId] + ".chunk.js";
};